import { render } from "./GameObject.vue?vue&type=template&id=5148a9ec"
import script from "./GameObject.vue?vue&type=script&lang=js"
export * from "./GameObject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__